import { percentageSignFilter } from "app/filters/ngFilters";

import { tiersConfig } from "app/common/keyword-research/keywords-overview/serpCompositionConsts";
import type {
    ISerpCompositionData,
    ISerpCompositionGraphItem,
    ISerpCompositionResponseData,
    SerpCompositionDataType,
} from "app/common/keyword-research/keywords-overview/serpCompositionTypes";

export const getValueAsPercentage = (value: number, decimal = 0): string => {
    return !value ? "-" : percentageSignFilter()(value, decimal);
};

export const transformSerpCompositionData = (data: ISerpCompositionResponseData): ISerpCompositionGraphItem[] => {
    if (!data) {
        return tiersConfig.map((config) => ({ ...config, y: 0 }));
    }
    const transformedData = Object.entries(data)?.map(
        ([key, value]: [SerpCompositionDataType, ISerpCompositionData]) => {
            const config = tiersConfig.find((tier) => tier.id === key);
            return {
                name: config.name,
                color: config.color,
                y: value.Percentage,
                total: value.Percentage,
                visible: true,
                id: key,
            };
        },
    );
    return transformedData;
};
